import type { NextTrip } from '@common/types/NextTrip'
import { mapOrd, rawOrd } from '@lc/libarray'
import {
	createEntityAdapter,
	createSlice,
	type WithSlice,
} from '@reduxjs/toolkit'
import { reducer } from './store'

export const nextTripsAdapter = createEntityAdapter({
	selectId: (nextTrip: NextTrip) =>
		`${nextTrip.line}/${nextTrip.direction}/${nextTrip.stop}`,
	sortComparer: mapOrd(
		rawOrd,
		nextTrip => `${nextTrip.line}/${nextTrip.direction}/${nextTrip.stop}`,
	),
})

declare module './store' {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	export interface LoadedSlices extends WithSlice<typeof nextTripsSlice> {}
}

const { selectById, selectIds, selectEntities } =
	nextTripsAdapter.getSelectors()

export type NextTripsSlice = ReturnType<
	(typeof nextTripsSlice)['getInitialState']
>
export const nextTripsSlice = createSlice({
	name: 'nextTrips',
	initialState: nextTripsAdapter.getInitialState(),
	reducers: {
		setNextTrip: nextTripsAdapter.setOne,
		setNextTrips: nextTripsAdapter.setMany,
		clearNextTrips: nextTripsAdapter.removeAll,
	},
	selectors: {
		getNextTrip: (
			state,
			line: string,
			direction: 'forward' | 'backward',
			stop: string,
		): NextTrip | undefined =>
			selectById(state, `${line}/${direction}/${stop}`),
		listNextTrips: selectIds,
		getAllNextTrips: selectEntities,
	},
})

export const {
	reducer: nextTripsReducer,
	actions: { setNextTrip, setNextTrips, clearNextTrips },
	selectors: { getNextTrip, listNextTrips, getAllNextTrips },
} = nextTripsSlice.injectInto(reducer)
